import { render, staticRenderFns } from "./KhqrAttemptDetailDrawer.vue?vue&type=template&id=72739728&scoped=true"
import script from "./KhqrAttemptDetailDrawer.vue?vue&type=script&lang=js"
export * from "./KhqrAttemptDetailDrawer.vue?vue&type=script&lang=js"
import style0 from "./KhqrAttemptDetailDrawer.vue?vue&type=style&index=0&id=72739728&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72739728",
  null
  
)

export default component.exports